
export const projectPromoTagsTransformer = data => {
  return data?.map(item => ({
      ...item,  
      value: item?.id?.toString(),
      label: item?.title,
    })
  )
}
